import React, { useState, useEffect } from 'react';
import { Button, Col, Grid, Row, Panel, Message, toaster } from 'rsuite';
import globalIP from '@/GlobelIP';
import { ControlCol, CustomInput } from '../../Costing/costing-page';
import { useFormik } from 'formik';

const CostingHeadMaster = () => {
  ////////////////  Function For 11 Start /////////////////
  const [cheadata, setCheadata] = useState<{
    attributes: {
      gst?: string;
      laison?: string;
      testing?: string;
      other?: string;
      overhead?: string;
      misc?: string;
      Profit?: string;
      FOB?: string;
      Innercarton?: string;
      MasterCarton?: string;
      L?: string;
      M?: string;
      X?: string;
    };
  }>({ attributes: {} });
  const [cheadId, setCheadId] = useState<number | undefined>(undefined);
  useEffect(() => {
    fetchData11();
  }, []);
  const fetchData11 = async () => {
    const pageResponse = await fetch(`${globalIP}/api/costingheads?populate=*`);
    const pageJson = await pageResponse.json();

    if (pageJson.data[0]) {
      setCheadata(pageJson.data[0]);
      setCheadId(pageJson.data[0]?.id);
    } else {
      setCheadata({ attributes: {} });
    }
  };

  useEffect(() => {
    // Update form values when cheadata changes
    formik.setValues({
      ...formik.values,
      gst: cheadata?.attributes?.gst || '',
      laison: cheadata?.attributes?.laison || '',
      testing: cheadata?.attributes?.testing || '',
      other: cheadata?.attributes?.other || '',
      overhead: cheadata?.attributes?.overhead || '',
      misc: cheadata?.attributes?.misc || '',
      Profit: cheadata?.attributes?.Profit || '',
      FOB: cheadata?.attributes?.FOB || '',
      Innercarton: cheadata?.attributes?.Innercarton || '',
      MasterCarton: cheadata?.attributes?.MasterCarton || '',
      L: cheadata?.attributes?.L || '',
      M: cheadata?.attributes?.M || '',
      X: cheadata?.attributes?.X || ''
    });
  }, [cheadata]);

  const formik = useFormik({
    initialValues: {
      gst: '',
      laison: '',
      testing: '',
      other: '',
      overhead: '',
      misc: '',
      Profit: '',
      FOB: '',
      Innercarton: '',
      MasterCarton: '',
      L: '',
      M: '',
      X: ''
    },
    onSubmit: async values => {
      const formData = new FormData();
      formData.append(
        'data',
        JSON.stringify({
          gst: values.gst || '0',
          laison: values.laison || '0',
          testing: values.testing || '0',
          other: values.other || '0',
          overhead: values.overhead || '0',
          misc: values.misc || '0',
          Profit: values.Profit || '0',
          FOB: values.FOB || '0',
          Innercarton: values.Innercarton || '0',
          MasterCarton: values.MasterCarton || '0',
          L: values.L || '0',
          M: values.M || '0',
          X: values.X || '0'
        })
      );
      if (cheadId) {
        const response = await fetch(`${globalIP}/api/costingheads/${cheadId}`, {
          method: 'PUT',
          body: formData
        });
        if (response.ok) {
          await fetchData11();

          toaster.push(
            <Message showIcon type="success">
              Data Updated Successfully.
            </Message>,
            { placement: 'topCenter' }
          );
        } else {
          console.error('Failed to update data');
        }
      } else {
        const response = await fetch(`${globalIP}/api/costingheads`, {
          method: 'POST',
          body: formData
        });

        if (response.ok) {
          fetchData11();

          toaster.push(
            <Message showIcon type="success">
              Data Save Successfully.
            </Message>,
            { placement: 'topCenter' }
          );
        } else {
          console.error('Failed to update data...');
        }
      }
    }
  });
  ////////////////  Function For 11 End /////////////////
  return (
    <div>
      <Panel>
        <form onSubmit={formik.handleSubmit}>
          <Grid fluid>
            <Row>
              <Col xs={4} style={{ marginBottom: '15px' }}>
                <ControlCol
                  label="Laison %"
                  control={
                    <CustomInput
                      placeholder="0.00"
                      name="laison"
                      value={formik.values.laison || '0'}
                      onChange={value => formik.setFieldValue('laison', value || '0')}
                    />
                  }
                />
              </Col>
              <Col xs={4} style={{ marginBottom: '15px' }}>
                <ControlCol
                  label="Testing %"
                  control={
                    <CustomInput
                      placeholder="0.00"
                      name="testing"
                      value={formik.values.testing || '0'}
                      onChange={value => formik.setFieldValue('testing', value || '0')}
                    />
                  }
                />
              </Col>
              <Col xs={4} style={{ marginBottom: '15px' }}>
                <ControlCol
                  label="Other %"
                  control={
                    <CustomInput
                      placeholder="0.00"
                      name="other"
                      value={formik.values.other || '0'}
                      onChange={value => formik.setFieldValue('other', value || '0')}
                    />
                  }
                />
              </Col>
              <Col xs={4} style={{ marginBottom: '15px' }}>
                <ControlCol
                  label="OverHead %"
                  control={
                    <CustomInput
                      placeholder="0.00"
                      name="overhead"
                      value={formik.values.overhead || '0'}
                      onChange={value => formik.setFieldValue('overhead', value || '0')}
                    />
                  }
                />
              </Col>
              <Col xs={4} style={{ marginBottom: '15px' }}>
                <ControlCol
                  label="Misc."
                  control={
                    <CustomInput
                      placeholder="0.00"
                      name="misc"
                      value={formik.values.misc || '0'}
                      onChange={value => formik.setFieldValue('misc', value || '0')}
                    />
                  }
                />
              </Col>
              <Col xs={4} style={{ marginBottom: '15px' }}>
                <ControlCol
                  label="Profit"
                  control={
                    <CustomInput
                      placeholder="0.00"
                      name="Profit"
                      value={formik.values.Profit || '0'}
                      onChange={value => formik.setFieldValue('Profit', value || '0')}
                    />
                  }
                />
              </Col>
              <Col xs={4} style={{ marginBottom: '15px' }}>
                <ControlCol
                  label="GST %"
                  control={
                    <CustomInput
                      placeholder="0.00"
                      name="gst"
                      value={formik.values.gst || '0'}
                      onChange={value => formik.setFieldValue('gst', value || '0')}
                    />
                  }
                />
              </Col>
              <Col xs={4} style={{ marginBottom: '15px' }}>
                <ControlCol
                  label="FOB"
                  control={
                    <CustomInput
                      placeholder="0.00"
                      name="FOB"
                      value={formik.values.FOB || '0'}
                      onChange={value => formik.setFieldValue('FOB', value || '0')}
                    />
                  }
                />
              </Col>
              <Col xs={4} style={{ marginBottom: '15px' }}>
                <ControlCol
                  label="Innercarton"
                  control={
                    <CustomInput
                      placeholder="0.00"
                      name="Innercarton"
                      value={formik.values.Innercarton || '0'}
                      onChange={value => formik.setFieldValue('Innercarton', value || '0')}
                    />
                  }
                />
              </Col>
              <Col xs={4} style={{ marginBottom: '15px' }}>
                <ControlCol
                  label="MasterCarton"
                  control={
                    <CustomInput
                      placeholder="0.00"
                      name="MasterCarton"
                      value={formik.values.MasterCarton || '0'}
                      onChange={value => formik.setFieldValue('MasterCarton', value || '0')}
                    />
                  }
                />
              </Col>
              <Col xs={4} style={{ marginBottom: '15px' }}>
                <ControlCol
                  label="L %"
                  control={
                    <CustomInput
                      placeholder="0.00"
                      name="L"
                      value={formik.values.L || '0'}
                      onChange={value => formik.setFieldValue('L', value || '0')}
                    />
                  }
                />
              </Col>
              <Col xs={4} style={{ marginBottom: '15px' }}>
                <ControlCol
                  label="M %"
                  control={
                    <CustomInput
                      placeholder="0.00"
                      name="M"
                      value={formik.values.M || '0'}
                      onChange={value => formik.setFieldValue('M', value || '0')}
                    />
                  }
                />
              </Col>
              <Col xs={4} style={{ marginBottom: '15px' }}>
                <ControlCol
                  label="MX %"
                  control={
                    <CustomInput
                      placeholder="0.00"
                      name="X"
                      value={formik.values.X || '0'}
                      onChange={value => formik.setFieldValue('X', value || '0')}
                    />
                  }
                />
              </Col>

              <Col xs={4} style={{ marginBottom: '15px', paddingTop: '14px' }}>
                <Button size="sm" color="cyan" appearance="primary" type="submit">
                  Save
                </Button>
              </Col>
            </Row>
          </Grid>
        </form>
      </Panel>
    </div>
  );
};

export default CostingHeadMaster;
